/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import { Dropdown } from "../reuseable";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle,
} from "chart.js";
import { Chart } from "react-chartjs-2";

/*REDUX*/
import {
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
  push_folder_chart_list,
  edit_folder_chart_list,
  delete_folder_chart_list,
} from "../../App/actions/propertiesActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { post_activities } from "../../App/actions/activities";

/*PICTURE*/
import chart_image_1 from "../../Assets/svg/chart_image_1.svg";
import chart_image_2 from "../../Assets/svg/chart_image_2.svg";

/*FUNCTION*/
import generate_array_color from "../../App/validation/generate_array_color";
import generate_uuid from "../../App/validation/generate_uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Title,
  SubTitle,
);

function MANAGE_CHART({
  auth,
  layer,
  project,
  properties,
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
  push_folder_chart_list,
  edit_folder_chart_list,
  delete_folder_chart_list,
  getDetailLayerById,
  post_activities,
}) {
  const [mode_input_chart, set_mode_input_chart] = useState("add");
  const [modal_input_chart, set_modal_input_chart] = useState(false);
  const [modal_delete_chart, set_modal_delete_chart] = useState(false);
  const [chart_id_delete, set_chart_id_delete] = useState("");
  const [chart_name_delete, set_chart_name_delete] = useState("");
  const [ina, set_ina] = useState("");
  const [eng, set_eng] = useState("");
  const [x_axis_field_key, set_x_axis_field_key] = useState("");
  const [is_use_y_axis, set_is_use_y_axis] = useState(false);
  const [y_axis_field_key, set_y_axis_field_key] = useState("");
  const [chart_type, set_chart_type] = useState("pie");
  const [is_use_custom_order, set_is_use_custom_order] = useState(true);
  const [x_element_custom_order, set_x_element_custom_order] = useState([]);
  const [color_default, set_color_default] = useState("#373784");
  const [color_hover, set_color_hover] = useState("#f38026");
  const [is_npv_kai, set_is_npv_kai] = useState(false);
  const [wacc_field_key, set_wacc_field_key] = useState("");
  const [folder_key, set_folder_key] = useState("");
  const [_id, set_id] = useState("");

  const [modal_input_folder, set_modal_input_folder] = useState(false);
  const [mode_input_folder, set_mode_input_folder] = useState("add");
  const [modal_delete_folder, set_modal_delete_folder] = useState(false);
  const [f_id, set_f_id] = useState("");
  const [f_title, set_f_title] = useState("");
  const [f_key, set_f_key] = useState("");
  const [folder_id_delete, set_folder_id_delete] = useState("");
  const [folder_title_delete, set_folder_title_delete] = useState("");

  const on_get_layer = useCallback(() => {
    const { layer_id, geo_layer_list } = layer;
    const { geo_project } = project;
    const layer_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    );

    if (!layer_item) {
      return;
    }
    const geo_layer_item = layer_item.geo_layer;
    const body = {
      geo_layer_id: geo_layer_item._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      folder_id: layer_item?.folder,
      capex_value: properties.capex_value,
      geo_layer_item,
    };
    getDetailLayerById(body);
  }, [layer, project, properties.capex_value, getDetailLayerById]);

  useEffect(() => {
    const { layer_id, geo_layer_list } = layer;
    const layer_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    );
    const features_length =
      layer_item?.geo_layer?.geojson?.features?.length || 0;

    if (features_length === 0) {
      on_get_layer();
    }
  }, [layer, on_get_layer]);

  const toggle_edit_chart = (chart_object) => {
    set_modal_input_chart((prev) => !prev);
    set_mode_input_chart("edit");
    if (chart_object) {
      set_id(chart_object._id || "");
      set_ina(chart_object.ina || "");
      set_eng(chart_object.eng || "");
      set_x_axis_field_key(chart_object.x_axis_field_key || "");
      set_is_use_y_axis(chart_object.is_use_y_axis || false);
      set_y_axis_field_key(chart_object.y_axis_field_key || "");
      set_chart_type(chart_object.chart_type || "pie");
      set_is_use_custom_order(
        chart_object.is_use_custom_order !== undefined
          ? chart_object.is_use_custom_order
          : true,
      );
      set_x_element_custom_order(chart_object.x_element_custom_order || []);
      set_color_default(chart_object.color_default || "#373784");
      set_color_hover(chart_object.color_hover || "#f38026");
      set_is_npv_kai(chart_object.is_npv_kai || false);
      set_wacc_field_key(chart_object.wacc_field_key || "");
      set_folder_key(chart_object.folder_key || "");
    }
  };

  const toggle_add_chart = () => {
    set_modal_input_chart((prev) => !prev);
    set_mode_input_chart("add");
    set_ina("");
    set_eng("");
    set_x_axis_field_key("");
    set_y_axis_field_key("");
    set_x_element_custom_order([]);
    set_folder_key("");
  };

  const toggle_add_folder = () => {
    set_modal_input_folder((prev) => !prev);
    set_mode_input_folder("add");
    set_f_id("");
    set_f_title("");
    set_f_key(generate_uuid());
  };

  const toggle_edit_folder = (folder_object) => {
    set_modal_input_folder((prev) => !prev);
    set_mode_input_folder("edit");
    if (folder_object) {
      set_f_id(folder_object._id || "");
      set_f_title(folder_object.title || "");
      set_f_key(folder_object.key || "");
    }
  };

  const toggle_delete_folder = (folder_id, folder_title) => {
    set_modal_delete_folder((prev) => !prev);
    if (folder_id !== undefined) set_folder_id_delete(folder_id);
    if (folder_title !== undefined) set_folder_title_delete(folder_title);
  };

  const move_up = (idx) => {
    set_x_element_custom_order((prev) => {
      const order_arr = [...prev];
      const length = order_arr.length;
      if (length === 0) return order_arr;
      if (idx !== 0) {
        const value = order_arr[idx];
        const value_before = order_arr[idx - 1];
        order_arr[idx - 1] = value;
        order_arr[idx] = value_before;
      } else {
        const value = order_arr[idx];
        const value_before = order_arr[length - 1];
        order_arr[length - 1] = value;
        order_arr[idx] = value_before;
      }
      return order_arr;
    });
  };

  const move_down = (idx) => {
    set_x_element_custom_order((prev) => {
      const order_arr = [...prev];
      const length = order_arr.length;
      if (length === 0) return order_arr;
      if (idx !== length - 1) {
        const value = order_arr[idx];
        const value_after = order_arr[idx + 1];
        order_arr[idx + 1] = value;
        order_arr[idx] = value_after;
      } else {
        const value = order_arr[idx];
        const value_after = order_arr[0];
        order_arr[0] = value;
        order_arr[idx] = value_after;
      }
      return order_arr;
    });
  };

  const on_get_x_element_custom_order = (x_axis_field_key_param) => {
    const { layer_id, geo_layer_list } = layer;
    const layer_object_item = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    );
    if (!layer_object_item) return;
    const geo_layer_item = layer_object_item.geo_layer;
    const features = geo_layer_item?.geojson?.features || [];
    const new_custom_order = [];
    features.forEach((feature) => {
      const raw_value = feature?.properties?.[x_axis_field_key_param];
      if (raw_value) {
        const split_values = String(raw_value).split("\n");
        split_values.forEach((val) => {
          const clean_val = val.trim();
          if (clean_val && !new_custom_order.includes(clean_val)) {
            new_custom_order.push(clean_val);
          }
        });
      }
    });
    set_x_element_custom_order(new_custom_order);
  };

  const on_submit_add = () => {
    const body = {
      geo_layer_id: layer.layer_id,
      chart_object: {
        ina,
        eng,
        x_axis_field_key,
        is_use_y_axis,
        y_axis_field_key,
        chart_type,
        color_default,
        color_hover,
        is_npv_kai,
        is_use_custom_order,
        x_element_custom_order,
        wacc_field_key,
        folder_key,
      },
    };
    push_chart_list(body);
    set_modal_input_chart(false);
    post_activities({
      action: "create_chart",
    });
  };

  const on_submit_edit = () => {
    const body = {
      geo_layer_id: layer.layer_id,
      chart_object: {
        _id,
        ina,
        eng,
        x_axis_field_key,
        is_use_y_axis,
        y_axis_field_key,
        chart_type,
        color_default,
        color_hover,
        is_npv_kai,
        is_use_custom_order,
        x_element_custom_order,
        wacc_field_key,
        folder_key,
      },
    };
    edit_chart_list(body);
    set_modal_input_chart(false);
  };

  const on_submit_add_folder = () => {
    const body = {
      geo_layer_id: layer.layer_id,
      folder_chart_object: {
        title: f_title,
        key: f_key,
      },
    };
    push_folder_chart_list(body);
    set_modal_input_folder(false);
  };

  const on_submit_edit_folder = () => {
    const body = {
      geo_layer_id: layer.layer_id,
      folder_chart_object: {
        _id: f_id,
        title: f_title,
        key: f_key,
      },
    };
    edit_folder_chart_list(body);
    set_modal_input_folder(false);
  };

  const on_change = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "ina") set_ina(value);
    else if (name === "eng") set_eng(value);
    else if (name === "chart_type") set_chart_type(value);
    else if (name === "folder_key") set_folder_key(value);
    else if (name === "wacc_field_key") set_wacc_field_key(value);
    else if (name === "color_default") set_color_default(value);
    else if (name === "color_hover") set_color_hover(value);
    else if (name === "f_title") set_f_title(value);
  };

  const on_toggle = (e) => {
    const { name } = e.target;
    if (name === "is_use_y_axis") set_is_use_y_axis((prev) => !prev);
    else if (name === "is_use_custom_order")
      set_is_use_custom_order((prev) => !prev);
    else if (name === "is_npv_kai") set_is_npv_kai((prev) => !prev);
  };

  const toggle_delete_chart = (chart_id, chart_name) => {
    set_modal_delete_chart((prev) => !prev);
    if (chart_id !== undefined) set_chart_id_delete(chart_id);
    if (chart_name !== undefined) set_chart_name_delete(chart_name);
  };

  const on_delete_chart_list = () => {
    const params = {
      geo_layer_id: layer.layer_id,
      chart_id: chart_id_delete,
    };
    delete_chart_list(params);
    set_modal_delete_chart(false);
  };

  const on_delete_folder_list = () => {
    const params = {
      geo_layer_id: layer.layer_id,
      folder_chart_id: folder_id_delete,
    };
    delete_folder_chart_list(params);
    set_modal_delete_folder(false);
  };

  const language = localStorage?.language || auth.language;
  const { layer_id, geo_layer_list } = layer;

  const layer_object_item = geo_layer_list.find(
    (item) => item.geo_layer._id === layer_id,
  );
  const layer_object = layer_object_item ? layer_object_item.geo_layer : {};
  const fields = layer_object?.fields || [];
  const chart_list = layer_object?.chart_list || [];
  const folder_chart_list = layer_object?.folder_chart_list || [];

  const modal_add_chart_content = modal_input_chart && (
    <Modal
      modalSize="large"
      id="modal_input_chart"
      isOpen={modal_input_chart}
      onClose={toggle_add_chart}
      title={
        mode_input_chart === "add"
          ? dict?.["Add New Chart"]?.[language]
          : dict?.["Edit Chart"]?.[language]
      }
    >
      <div className="box-body">
        <main className="max_height">
          <section className="container background_grey_light">
            <h2 className="text_bold sub_color margin_bottom">
              {dict?.["Title"]?.[language]}
            </h2>
            <input
              className="margin_bottom"
              value={ina}
              name="ina"
              onChange={on_change}
              type="text"
              placeholder={dict?.["Title"]?.[language]}
            />

            <div className="margin_bottom">
              <p className="text_bold sub_color margin_bottom">Folder</p>
              <select value={folder_key} name="folder_key" onChange={on_change}>
                <option value="">-- No Folder --</option>
                {folder_chart_list.map((f) => (
                  <option key={f.key} value={f.key}>
                    {f.title}
                  </option>
                ))}
              </select>
            </div>

            <div className="margin_bottom">
              <p className="text_bold sub_color margin_bottom">
                {dict?.["Chart type"]?.[language]}
              </p>
              <select value={chart_type} name="chart_type" onChange={on_change}>
                <option value="line">Line chart (Grafik garis)</option>
                <option value="bar">Bar chart (Grafik batang)</option>
                <option value="pie">Pie chart (Grafik lingkaran)</option>
                <option value="doughnut">Doughnut chart (Grafik donat)</option>
                <option value="polarArea">
                  Polar Area chart (Grafik area polar)
                </option>
              </select>
            </div>

            <div className="margin_bottom">
              <p className="text_bold sub_color margin_bottom">
                {dict?.["Text/label column"]?.[language]}
              </p>
              <Dropdown
                placeholder={dict?.["Select the text column"]?.[language]}
                filter_on
                is_enable_empty={false}
                value={x_axis_field_key}
                onChange={(value) => {
                  set_x_axis_field_key(value);
                  on_get_x_element_custom_order(value);
                }}
              >
                {fields.map((field) => {
                  return (
                    <option key={field.key} value={field.key}>
                      {field.name}
                    </option>
                  );
                })}
              </Dropdown>
            </div>

            <div className="container background_white margin_bottom">
              <p className="badge_small green_container">
                Nilai diextract dari data asli
              </p>
              <table className="table margin_top">
                <tbody>
                  {x_element_custom_order.map((item, idx) => {
                    return (
                      <tr key={idx}>
                        <td>
                          <button
                            className="button button_white outline_black"
                            onClick={() => move_up(idx)}
                          >
                            ↑
                          </button>
                        </td>
                        <td>
                          <span className="badge_small background_grey_light">
                            {item}
                          </span>
                        </td>
                        <td>
                          <button
                            className="button button_white outline_black"
                            onClick={() => move_down(idx)}
                          >
                            ↓
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <h2 className="text_bold sub_color margin_bottom">
              {dict?.["Select chart mode"]?.[language]}
            </h2>
            <div className="two_container_equal margin_bottom">
              <div
                className={`container ${
                  !is_use_y_axis
                    ? "background_white outline_black"
                    : "background_grey outline_grey"
                }`}
              >
                <div className="text_center margin_bottom">
                  <button
                    className={`${
                      !is_use_y_axis ? "checklist_active" : "checklist_not"
                    }`}
                    name="is_use_y_axis"
                    onClick={on_toggle}
                  />
                  <p className="text_medium">
                    {dict?.["Single-column text mode"]?.[language]}
                  </p>
                  <p className="text_medium sub_color margin_bottom">
                    {
                      dict?.["Aggregate of the same number of items"]?.[
                        language
                      ]
                    }
                  </p>
                </div>
                <div className="text_center">
                  <img
                    src={chart_image_1}
                    alt="chart_image_1"
                    style={{
                      height: "189px",
                      maxWidth: "100%",
                    }}
                  />
                </div>
              </div>
              <div
                className={`container ${
                  is_use_y_axis
                    ? "background_white outline_black"
                    : "background_grey outline_grey"
                }`}
              >
                <div className="text_center margin_bottom">
                  <button
                    className={`${
                      is_use_y_axis ? "checklist_active" : "checklist_not"
                    }`}
                    name="is_use_y_axis"
                    onClick={on_toggle}
                  />
                  <p className="text_medium">
                    {
                      dict?.[
                        "Single column text and single column numbers mode"
                      ]?.[language]
                    }
                  </p>
                  <p className="text_medium sub_color margin_bottom">
                    {
                      dict?.[
                        "Sum the columns of numbers with the same items"
                      ]?.[language]
                    }
                  </p>
                </div>

                <div className="text_center">
                  <img
                    src={chart_image_2}
                    alt="chart_image_2"
                    style={{
                      height: "189px",
                      maxWidth: "100%",
                    }}
                  />
                </div>

                <div className="margin_bottom">
                  <p className="text_bold sub_color margin_bottom">
                    {dict?.["Number column"]?.[language]}
                  </p>
                  <Dropdown
                    placeholder={dict?.["Select the number column"]?.[language]}
                    filter_on
                    is_enable_empty={false}
                    value={y_axis_field_key}
                    onChange={(value) => {
                      set_y_axis_field_key(value);
                    }}
                  >
                    {fields.map((field) => {
                      return (
                        <option key={field.key} value={field.key}>
                          {field.name}
                        </option>
                      );
                    })}
                  </Dropdown>
                </div>
              </div>
            </div>
          </section>

          <section className="text_center margin_top">
            {mode_input_chart === "add" ? (
              <button
                className="button_big background_black"
                onClick={on_submit_add}
              >
                {dict?.["Save"]?.[language]}
              </button>
            ) : (
              <button
                className="button_big background_black"
                onClick={on_submit_edit}
              >
                {dict?.["Save changes"]?.[language]}
              </button>
            )}
          </section>
        </main>
      </div>
    </Modal>
  );

  const modal_delete_chart_content = modal_delete_chart && (
    <Modal
      modalSize="small"
      id="toggle_delete_chart"
      isOpen={modal_delete_chart}
      onClose={toggle_delete_chart}
    >
      <div className="box-body">
        <h1 className="text_header">
          {dict?.["Confirm delete chart"]?.[language]}
        </h1>
        <table className="table">
          <tbody>
            <tr>
              <td>{dict?.["Name"]?.[language]}</td>
              <td>{chart_name_delete}</td>
            </tr>
          </tbody>
        </table>
        <p className="text_medium">
          {dict?.["Deleted charts cannot be restored."]?.[language]}
        </p>
        <br />
        <br />
        <button
          className="button background_red"
          onClick={on_delete_chart_list}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </Modal>
  );

  const modal_add_folder_content = modal_input_folder && (
    <Modal
      modalSize="small"
      id="modal_input_folder"
      isOpen={modal_input_folder}
      onClose={toggle_add_folder}
    >
      <div className="box-body">
        <h1 className="text_header">
          {mode_input_folder === "add" ? "Add Folder" : "Edit Folder"}
        </h1>

        <section className="container background_grey_light">
          <h2 className="text_bold sub_color margin_bottom">
            {dict?.["Title"]?.[language]}
          </h2>
          <input
            className="margin_bottom"
            value={f_title}
            name="f_title"
            onChange={on_change}
            type="text"
            placeholder={dict?.["Title"]?.[language]}
          />
        </section>

        <section className="text_center margin_top">
          <button
            className="button_big background_black"
            onClick={
              mode_input_folder === "add"
                ? on_submit_add_folder
                : on_submit_edit_folder
            }
          >
            {mode_input_folder === "add"
              ? dict?.["Save"]?.[language]
              : dict?.["Save changes"]?.[language]}
          </button>
        </section>
      </div>
    </Modal>
  );

  const modal_delete_folder_content = modal_delete_folder && (
    <Modal
      modalSize="small"
      id="toggle_delete_folder"
      isOpen={modal_delete_folder}
      onClose={toggle_delete_folder}
    >
      <div className="box-body">
        <h1 className="text_header">Confirm delete folder</h1>
        <table className="table">
          <tbody>
            <tr>
              <td>{dict?.["Name"]?.[language]}</td>
              <td>{folder_title_delete}</td>
            </tr>
          </tbody>
        </table>
        <p className="text_medium">
          Note: This will delete the folder, but charts inside it will remain
          without a folder.
        </p>
        <br />
        <br />
        <button
          className="button background_red"
          onClick={on_delete_folder_list}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </Modal>
  );

  const render_chart_item = (item, idx) => {
    const { chart_type, chart_js_data } = item;
    if (
      !chart_js_data ||
      !chart_js_data.datasets ||
      !chart_js_data.datasets[0]
    ) {
      return null;
    }
    let chartData = { ...chart_js_data };
    const label_array = chartData.datasets[0].labels || [];
    const value_array = chartData.datasets[0].data || [];
    const color_array = generate_array_color(label_array);
    chartData.datasets[0].backgroundColor = color_array;
    chartData.datasets[0].borderColor = color_array;
    chartData.datasets[0].borderWidth = 1;
    const is_circle_chart = ["pie", "doughnut", "polarArea"].includes(
      chart_type,
    );
    const isLongChart = ["bar", "line", "area"].includes(chart_type);
    const chartHeight = isLongChart ? 150 : undefined;
    const numericData = value_array.map((d) =>
      typeof d === "object" && d !== null ? d.y : d,
    );
    const total = numericData.reduce((sum, val) => sum + val, 0);
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: !isLongChart,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
      scales: isLongChart
        ? {
            x: {
              beginAtZero: true,
              ticks: { display: chart_type === "line" },
            },
            y: {
              beginAtZero: true,
            },
          }
        : {},
    };

    const custom_legend = (
      <section
        className="container background_white"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px",
          maxHeight: "200px",
          overflowY: "auto",
          overflowX: "hidden",
          borderRadius: "5px",
        }}
      >
        <table>
          <tbody>
            {label_array.map((label, index) => {
              const count = numericData[index];
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";
              return (
                <tr
                  key={index}
                  style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                >
                  <td
                    style={{
                      verticalAlign: "top",
                      paddingRight: "8px",
                      textAlign: "center",
                      width: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "15px",
                        height: "15px",
                        backgroundColor: color_array[index] || "transparent",
                        margin: "0 auto",
                      }}
                    />
                  </td>
                  <td>
                    <div>
                      <p className="text_medium">{label} </p>
                      <span className="text_small">{count}</span>{" "}
                      <span className="text_small sub_color">
                        ({percentage} %)
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    );

    let final_content;

    if (is_circle_chart) {
      final_content = (
        <main
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          <section style={{ width: "77px" }}>
            <Chart
              type={chart_type}
              data={chartData}
              options={chartOptions}
              style={{ height: chartHeight, maxHeight: chartHeight }}
            />
          </section>
          <section style={{ width: "100%" }}>{custom_legend}</section>
        </main>
      );
    } else {
      final_content = (
        <main style={{ width: "100%" }}>
          <div
            style={{
              overflowX: "auto",
              paddingBottom: "1rem",
            }}
          >
            <div
              style={{ minWidth: `${label_array.length * 30}px` }}
              className="container background_white"
            >
              <Chart
                type={chart_type}
                data={chartData}
                options={chartOptions}
                style={{
                  height: chartHeight,
                  maxHeight: chartHeight,
                }}
              />
            </div>
          </div>
          {custom_legend}
        </main>
      );
    }

    return (
      <section
        key={idx}
        className="container background_white outline_grey margin_bottom margin_right"
        style={{
          width: "279px",
          display: "inline-block",
          verticalAlign: "top",
        }}
      >
        <h2 className="text_medium sub_color margin_bottom">{item.ina}</h2>
        <section>
          <button
            className="button_small background_black margin_right margin_bottom"
            onClick={() => toggle_edit_chart(item)}
          >
            Edit
          </button>
          <button
            className="button_small background_red margin_right margin_bottom"
            onClick={() => toggle_delete_chart(item._id, item.ina)}
          >
            {dict?.["Delete"]?.[language]}
          </button>
        </section>
        {final_content}
      </section>
    );
  };

  const charts_without_folder = chart_list.filter(
    (c) =>
      !c.folder_key ||
      !folder_chart_list.some((folder) => folder.key === c.folder_key),
  );

  return (
    <main className="max_height">
      {modal_delete_chart_content}
      {modal_add_chart_content}
      {modal_add_folder_content}
      {modal_delete_folder_content}

      <section className="text_center margin_top margin_bottom">
        <button
          className="button_big button_white outline_black margin_right"
          onClick={toggle_add_chart}
        >
          {dict?.["Add a chart"]?.[language]}
        </button>
        <button
          className="button_big button_white outline_black"
          onClick={toggle_add_folder}
        >
          Buat folder baru
        </button>
      </section>

      <section>
        {chart_list.length === 0 && folder_chart_list.length === 0 ? (
          <div className="container background_grey_light">
            {dict?.["No graph has been created for this layer yet"]?.[language]}
          </div>
        ) : (
          <div>
            {folder_chart_list.map((folder, folder_idx) => {
              const charts_in_folder = chart_list.filter(
                (c) => c.folder_key === folder.key,
              );
              return (
                <div
                  key={folder._id || folder_idx}
                  className="container background_grey_light margin_bottom"
                  style={{ padding: "15px", borderRadius: "8px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <h2 className="text_bold">{folder.title}</h2>
                    <div>
                      <button
                        className="button_small background_black margin_right"
                        onClick={() => toggle_edit_folder(folder)}
                      >
                        Edit Folder
                      </button>
                      <button
                        className="button_small background_red"
                        onClick={() =>
                          toggle_delete_folder(folder._id, folder.title)
                        }
                      >
                        Delete Folder
                      </button>
                    </div>
                  </div>

                  <div>
                    {charts_in_folder.length > 0 ? (
                      charts_in_folder.map((item, idx) =>
                        render_chart_item(item, idx),
                      )
                    ) : (
                      <p className="text_small sub_color">
                        No charts in this folder
                      </p>
                    )}
                  </div>
                </div>
              );
            })}

            {charts_without_folder.length > 0 && (
              <div
                className="container background_grey_light margin_bottom"
                style={{ padding: "15px", borderRadius: "8px" }}
              >
                <h2 className="text_bold margin_bottom">
                  Uncategorized Charts
                </h2>
                <div>
                  {charts_without_folder.map((item, idx) =>
                    render_chart_item(item, idx),
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </section>
    </main>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  push_chart_list,
  delete_chart_list,
  edit_chart_list,
  push_folder_chart_list,
  edit_folder_chart_list,
  delete_folder_chart_list,
  getDetailLayerById,
  post_activities,
})(MANAGE_CHART);
